import * as ngCdkOverlay from '@angular/cdk/overlay'
import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../state'
import * as base from '../base'

/**
 * Displays information about the selected/hovered {@link state.summit.allocations.models.Unit}
 */
@ngCore.Component({
  imports: [base.Component],
  selector: 'atn-summit-allocation-graph-unit-overlay',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Indicates where this overlay {@link Component} should be placed
   */
  public readonly originSg =
    ngCore.input.required<ngCdkOverlay.FlexibleConnectedPositionStrategyOrigin>(
      {
        alias: 'origin',
      },
    )

  /**
   * {@link state.summit.allocations.models.Unit} to display in this overlay {@link Component}
   */
  public readonly unitSg =
    ngCore.input.required<state.summit.allocations.models.Unit>({
      alias: 'unit',
    })
}
